export default "__VITE_ASSET__Drwtk1Tf__"